import { Modal, Button } from "@marekl/adminer/components";
import { useVoidBarcode } from "../../../lib/queries/barcodeBank";
import { notifySuccess, notifyError } from "@marekl/adminer/api";
import styles from "./VoidConfirmModal.module.css";

interface VoidConfirmModalProps {
  barcode: string | null;
  onClose: () => void;
}

export function VoidConfirmModal({ barcode, onClose }: VoidConfirmModalProps) {
  const voidBarcode = useVoidBarcode();

  async function handleConfirm() {
    if (!barcode) return;
    try {
      await voidBarcode.mutateAsync(barcode);
      notifySuccess(`Kód ${barcode} byl vyřazen.`);
      onClose();
    } catch (err) {
      notifyError(err);
    }
  }

  return (
    <Modal
      open={barcode !== null}
      title="Vyřadit kód"
      onClose={onClose}
      width={440}
      footer={
        <>
          <Button onClick={onClose}>Zrušit</Button>
          <Button
            variant="danger"
            loading={voidBarcode.isPending}
            onClick={handleConfirm}
          >
            Vyřadit
          </Button>
        </>
      }
    >
      <p className={styles.text}>
        Opravdu chcete vyřadit kód <code className={styles.code}>{barcode}</code>?
        Tato akce je nevratná.
      </p>
    </Modal>
  );
}
